import React, { useEffect, useState } from "react";
import { db } from "../../firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import Swal from "sweetalert2";

export default function ManageStatistikSekolah() {
  const [form, setForm] = useState({
    jumlahGuru: "",
    jumlahPegawai: "",
    jumlahSiswa: "",
  });

  const [loading, setLoading] = useState(false);
  const ref = doc(db, "informasi", "statistikSekolah");

  // 🔹 Ambil data awal
  useEffect(() => {
    const fetchData = async () => {
      const snap = await getDoc(ref);
      if (snap.exists()) {
        const data = snap.data();
        setForm({
          jumlahGuru: data.jumlahGuru ?? "",
          jumlahPegawai: data.jumlahPegawai ?? "",
          jumlahSiswa: data.jumlahSiswa ?? "",
        });
      }
    };
    fetchData();
  }, []);

  // 🔹 Hanya angka
  const handleChange = (e) => {
    const { name, value } = e.target;
    const onlyNumber = value.replace(/[^0-9]/g, "");
    setForm((p) => ({ ...p, [name]: onlyNumber }));
  };

  // 🔹 Simpan ke Firestore
  const handleSave = async () => {
    if (!form.jumlahGuru || !form.jumlahPegawai || !form.jumlahSiswa) {
      return Swal.fire("Validasi", "Semua field wajib diisi", "warning");
    }

    setLoading(true);
    try {
      await setDoc(ref, {
        jumlahGuru: Number(form.jumlahGuru),
        jumlahPegawai: Number(form.jumlahPegawai),
        jumlahSiswa: Number(form.jumlahSiswa),
        updatedAt: new Date().toISOString(),
      });

      Swal.fire("Berhasil", "Statistik sekolah diperbarui", "success");
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Gagal menyimpan data", "error");
    }
    setLoading(false);
  };

  return (
    <div className="container mt-4" style={{ maxWidth: 500 }}>
      <h3 className="mb-4">Kelola Statistik Sekolah</h3>

      <div className="card p-4 shadow-sm">

        <div className="mb-3">
          <label>Jumlah Tenaga Pendidik</label>
          <input
            className="form-control"
            name="jumlahGuru"
            value={form.jumlahGuru}
            onChange={handleChange}
            placeholder="Contoh: 32"
          />
        </div>

        <div className="mb-3">
          <label>Jumlah Pegawai</label>
          <input
            className="form-control"
            name="jumlahPegawai"
            value={form.jumlahPegawai}
            onChange={handleChange}
            placeholder="Contoh: 12"
          />
        </div>

        <div className="mb-3">
          <label>Jumlah Peserta Didik</label>
          <input
            className="form-control"
            name="jumlahSiswa"
            value={form.jumlahSiswa}
            onChange={handleChange}
            placeholder="Contoh: 450"
          />
        </div>

        <button
          className="btn btn-primary w-100"
          onClick={handleSave}
          disabled={loading}
        >
          {loading ? "Menyimpan..." : "Simpan Statistik"}
        </button>
      </div>
    </div>
  );
}
